import type { TypePolicies } from '@apollo/client';
import { relayStylePagination } from '@apollo/client/utilities';

const typePolicies: TypePolicies = {
    Query: {
        fields: {
            tournaments: relayStylePagination(['filter', ['name', ['contains']]]),
            teams: relayStylePagination(['filter', ['name', ['contains'], 'titleId']]),
            players: relayStylePagination([
                'filter',
                ['teamIdFilter', ['id'], ['nickname', ['contains']], 'titleId', 'types'],
            ]),
            events: relayStylePagination([['filter', ['event', ['type', ['eq']]]], 'id']),
        },
    },
};

export default typePolicies;
